import { render, staticRenderFns } from "./sisterRound.vue?vue&type=template&id=823a5358&scoped=true&"
import script from "./sisterRound.vue?vue&type=script&lang=js&"
export * from "./sisterRound.vue?vue&type=script&lang=js&"
import style0 from "./sisterRound.vue?vue&type=style&index=0&id=823a5358&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823a5358",
  null
  
)

export default component.exports